import { DataProvider, GetListResult } from 'react-admin'
import { throwNotSupported } from '@/dataProvider'
import getVendorBatches from '../repository/getVendorBatches'

type ApiBatch = {
  id: string
  date: string
  shipped_items_count: number
  total_items_count: number
  late_items_count: number
  refunded_items_count: number
  last_downloaded_at?: string
}

const physicalOrdersProvider: DataProvider = {
  getList: async (_resource, params) => {
    const response = await getVendorBatches(params)

    if ('error' in response) {
      throw new Error(response.error)
    }

    const total = response.total_entries
    const data = response.batches
      .map(parsePhysicalOrders)
      .filter((item): item is NonNullable<typeof item> => item !== null)
    return { data, total } as GetListResult
  },
  getOne: throwNotSupported,
  getMany: throwNotSupported,
  getManyReference: throwNotSupported,
  update: throwNotSupported,
  updateMany: throwNotSupported,
  create: throwNotSupported,
  delete: throwNotSupported,
  deleteMany: throwNotSupported
}

const parsePhysicalOrders = (batch: ApiBatch) => {
  if (!batch) return null

  return {
    id: parseInt(batch.id),
    date: new Date(batch.date),
    shipped: batch.shipped_items_count,
    open: batch.total_items_count,
    late: batch.late_items_count,
    refunds: batch.refunded_items_count,
    total:
      batch.total_items_count +
      batch.shipped_items_count +
      batch.refunded_items_count,
    lastDownloadedAt: batch.last_downloaded_at
      ? new Date(batch.last_downloaded_at)
      : undefined
  }
}

export default physicalOrdersProvider
